// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/ScoreList/ScoreList.scss
// module id = 816
// module chunks = 0